import {getToken} from '../../utils/getToken';
import {downloadBlob} from '../../utils/downloadFile';
import {getPromiseForAsyncNotification} from '../../utils/notificationHelpers';
import {showNotificationAction} from '../actions';
import {getCurrentProjectScope} from '../selectors';
import {NotificationLevels, NotificationTypes} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import i18n from '../../utils/i18n';
import {downloadAttachmentContentsToBlob} from '../../utils/data-transfer-helpers';

const MIME_TYPE_STREAM = 'octet/stream';

export default class AttachmentDownloadThunk {
  static downloadAttachment = (attachment, asyncMessage, failureMessage) => (dispatch, getState) => {
    const notificationPromise = getPromiseForAsyncNotification();
    dispatch(
      showNotificationAction({
        type: NotificationTypes.TOAST,
        level: NotificationLevels.SUCCESS,
        message: asyncMessage,
        autoDismiss: 0.5,
        asyncOperation: notificationPromise.promise,
        closeButtonTooltipText: i18n.t('notifications.downloadWillContinue')
      })
    );

    getToken({getState, dispatch})
      .then(token =>
        downloadAttachmentContentsToBlob({
          attachment,
          token,
          projectScope: getCurrentProjectScope(getState()),
          mimeType: MIME_TYPE_STREAM
        })
      )
      .then(blob => {
        notificationPromise.resolve();
        downloadBlob(blob, attachment.name);
      })
      .catch(() => {
        notificationPromise.reject();
        dispatch(
          showNotificationAction({
            type: NotificationTypes.SNACKBAR,
            level: NotificationLevels.ERROR,
            message: failureMessage
          })
        );
      });
  };
}
